import React, { useState, useEffect } from "react";
import { ForwardButtonState, Props } from "../../types/props";
import { ROUTES } from "../../constants/clientRoutes";
import { ACTION_DISPLAY_TYPES } from "../../constants/enums";

import FlowScreen from "../../components/Layouts/FlowScreen";
import AccountSelection from "./AccountSelection";
import Action from "../../components/Common/Action";
import AllocationConfirmation from "./AllocationConfirmation";
import SelectFreeTransfer from "./SelectFreeTransfer";
import SelectAllocationType from "./SelectAllocationType";
import SpecificAmount from "./SpecificAmount";
import RemainingAmount from "./RemainingAmount";
import PercentageSplit from "./PercentageSplit";
import ApiErrorModal from "../../components/Common/Modals/ApiErrorModal";

const AllocationWizard = (props: Props) => {
  const [title, setTitle] = useState("");
  const [page, setPage] = useState("");
  const [forwardButton, setForwardButton] = useState<ForwardButtonState>({
    text: "",
    onClick: () => { },
    disabled: false,
    loading: false
  });

  const childProps = { setTitle, setForwardButton };

  useEffect(() => {
    setPage(props.location?.pathname ?? "");
  }, [props.location?.pathname]);

  return (
    <FlowScreen
      flowTitle={title}
      className="position-relative"
      showBackButton={true}
    >

      {/* Account Selection */}
      {page === ROUTES.ALLOCATIONS.ACCOUNT_SELECTION && <AccountSelection {...childProps} />}

      {/* Select Free Transfer */}
      {page === ROUTES.ALLOCATIONS.SELECT_FREE_TRANSFER && <SelectFreeTransfer {...childProps} />}

      {/* Select Allocation Type */}
      {page === ROUTES.ALLOCATIONS.SELECT_ALLOCATION_TYPE && <SelectAllocationType {...childProps} />}

      {/* Specific Amount */}
      {page === ROUTES.ALLOCATIONS.SPECIFIC_AMOUNT && <SpecificAmount {...childProps} />}

      {/* Remaining Amount */}
      {page === ROUTES.ALLOCATIONS.REMAINING_AMOUNT && <RemainingAmount {...childProps} />}

      {/* Percentage */}
      {page === ROUTES.ALLOCATIONS.PERCENTAGE_SPLIT && <PercentageSplit {...childProps} />}

      {/* Confirmation */}
      {(page === ROUTES.ALLOCATIONS.CONFIRMATION && props.location?.state) && <AllocationConfirmation {...childProps} {...props} />}


      {forwardButton?.text &&
        <Action
          title={forwardButton.text}
          displayType={ACTION_DISPLAY_TYPES.PRIMARY}
          onClick={forwardButton.onClick}
          disabled={forwardButton.disabled}
          loading={forwardButton.loading}
          className="mt-16"
          type="submit"
        />
      }

      <ApiErrorModal />
    </FlowScreen>
  );
}

export default AllocationWizard;